import { useCallback } from 'react';

import { useCommentsData } from '@confluence/comments-data';
import { useCommentsPanelActions } from '@confluence/comments-panel-utils';

import {
	createReadCommentsDataMap,
	getCommentIdsByTypeAndAnnotationId,
} from '../helper/commentHelpers';

export const useSyncReadComments = () => {
	const { setCommentsToBeMarkedAsRead } = useCommentsPanelActions();
	const [{ commentsDataMap }, { setCommentsDataMap }] = useCommentsData();

	return useCallback(() => {
		setCommentsToBeMarkedAsRead(getCommentIdsByTypeAndAnnotationId(commentsDataMap));
		setCommentsDataMap(createReadCommentsDataMap(commentsDataMap));
	}, [commentsDataMap, setCommentsToBeMarkedAsRead, setCommentsDataMap]);
};
